<template>
	<div class="is-flex is-flex-wrap-nowrap">
		<div class="flex-item-expanded">
			<o-inputitems
				v-model="items"
				:allowDuplicates="false"
				:allowNew="false"
				:keepOpen="false"
				:data="acOptionsFiltered"
				:debounceTyping="300"
				field="Text"
				:placeholder="placeholder"
				:openOnFocus="true"
				expanded
				autocomplete
				:hasCounter="false"
				:maxitems="maxitems"
				:clear-on-select="clearOnSelect"
				@typing="LoadAcOptions"
				@focus="
					focussing = true;
					LoadAcOptions();
				"
				@blur="focussing = false"
				@add="UpdateModel"
				@remove="UpdateModel"
				@update="UpdateChanged">
				<template v-slot:empty>No results</template>
			</o-inputitems>
		</div>
		<o-button
			icon-left="chevron-up"
			inverted
			class="ac-uncollapse"
			v-show="focussing"
			style="margin-left: -1px"></o-button>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted, nextTick, watch } from "vue";
	import { max } from "moment";
	export default {
		props: {
			modelValue: {
				type: Array,
				default: null
			},
			type: {
				type: String,
				default: null
			},
			data: {
				type: Array,
				default: () => {
					return [];
				}
			},
			placeholder: {
				type: String,
				default: ""
			},
			clearOnSelect: {
				type: Boolean,
				default: false
			},
			companyId: {
				type: Number,
				default: null
			},
			blfCertified: {
				type: Boolean,
				default: false
			},
			maxitems: {
				type: Number,
				default: 1
			}
		},
		emits: ["update:modelValue", "input", "UpdateChanged", "loaded"],
		setup(props, context) {
			const $http = inject("$http");

			const focussing = ref(false);
			const items = ref(props.modelValue || []);
			//const items = ref([]);
			const text = ref([]);

			const options = ref([]);

			const UpdateModel = () => {
				context.emit("update:modelValue", items.value);
				UpdateChanged();
			};
			const UpdateChanged = () => {
				context.emit("UpdateChanged", true);
			};

			const acOptionsFiltered = computed(() => {
				return options.value.filter(
					(option) =>
						(option.Text || "")
							.toString()
							.toLowerCase()
							.indexOf((text.value || "").toLowerCase()) >= 0
				);
			});

			const url = computed(() => {
				const qs =
					"?" +
					[
						{ k: "query", v: text.value || "" },
						{ k: "companyId", v: props.companyId },
						{ k: "blf_certified", v: props.blfCertified },
						...(props.type === "industry"
							? [
								{ k: "distinctNames", v: true },
								...(items.value || []).map((item) => ({ k: "selectedIds", v: item.Id }))
							]
							: [])
					]
						.filter((r) => r.v)
						.map((r) => r.k + "=" + r.v)
						.join("&");
				switch (props.type) {
					case "function": {
						return "/api/v2/function/filter" + qs;
					}
					case "industry": {
						return "/api/v2/industry/filter" + qs;
					}
					case "region": {
						return "/api/v2/region/filter" + qs;
					}
					case "license": {
						return "/api/v2/license/filter" + qs;
					}
					case "location": {
						return "/api/v2/location/filter" + qs;
					}
					case "country": {
						return "/api/v2/country/filter" + qs;
					}
					case "company": {
						return "/api/v2/company/filter" + qs;
					}
					case "user": {
						return "/api/v2/user/filter" + qs;
					}
					case "developer": {
						return "/api/v2/user/filter/developers" + qs;
					}
					case "researcher": {
						return "/api/v2/user/filter/researchers" + qs;
					}
					case "handler": {
						return "/api/v2/user/filter/handlers" + qs;
					}
					case "practiceGroup": {
						return "/api/v2/practiceGroup/filter" + qs;
					}
					case "subsector": {
						return "/api/v2/practiceGroup/subsectors/filter" + qs;
					}
					case "skill": {
						return "/api/v2/skill/filter" + qs;
					}
					default:
						return null;
				}
			});

			const LoadAcOptions = (inputText) => {
				if (inputText == undefined || typeof inputText != "string") {
					text.value = "";
				} else {
					text.value = inputText;
				}

				if (url.value) {
					$http
						.get(url.value)
						.then((resp) => {
							options.value = resp.data;
							context.emit("loaded", { options: options.value });
						})
						.catch((err) => {
							options.value = [];
						});
				} else {
					options.value = props.data;
				}
			};

			const ConvertTypeIdToListItem = (row) => {
				switch (props.type) {
					case "function": {
						return { Id: row.ID, Text: row.Name };
					}
					case "industry": {
						return { Id: row.ID, Text: row.Name };
					}
					case "region": {
						return { Id: row.ID, Text: row.Name };
					}
					case "license": {
						return { Id: row.ID, Text: row.Name };
					}
					case "location": {
						return { Id: row.ID, Text: row.Name };
					}
					case "country": {
						return { Id: row.ID, Text: row.Name };
					}
					case "company": {
						return { Id: row.ID, Text: row.Name };
					}
					case "user": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "developer": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "researcher": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "handler": {
						return { Id: row.ID, Text: row.FullName };
					}
					case "practiceGroup": {
						return { Id: row.ID, Text: row.Name };
					}
					case "subsector": {
						return { Id: row.ID, Text: row.Name };
					}
					case "skill": {
						return { Id: row.ID, Text: row.Name };
					}
					default: {
						return { Id: 0, Text: "Null" };
					}
				}
			};

			watch(
				() => props.companyId,
				() => {
					LoadAcOptions(text.value);
				}
			);
			watch(
				() => props.modelValue,
				(n, o) => {
					if (n != o) {
						items.value = n;
					}
				}
			);

			onMounted(async () => {
				await LoadAcOptions();
			});

			return {
				text,
				focussing,
				items,
				acOptionsFiltered,
				LoadAcOptions,
				UpdateModel,
				UpdateChanged
			};
		}
	};
</script>
